import { render, staticRenderFns } from "./paragraph-editable.vue?vue&type=template&id=b7fac434&scoped=true&"
import script from "./paragraph-editable.vue?vue&type=script&lang=ts&"
export * from "./paragraph-editable.vue?vue&type=script&lang=ts&"
import style0 from "./paragraph-editable.vue?vue&type=style&index=0&id=b7fac434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fac434",
  null
  
)

export default component.exports